
import React, { useState, useEffect, useRef } from 'react';
import AppBar from '@mui/material/AppBar';
import { useNavigate } from 'react-router-dom';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { Menu, MenuItem, Button, IconButton } from '@mui/material';
import Box from '@mui/material/Box';
import logo from './alpha_grandrapids_logo_white-small.png'; // Adjust the path to your image
import smllogo from './AGR_Bug_RGB_small.png';
import { useTheme } from '@mui/material/styles';
function Header() {
  const theme = useTheme(); // Access the Material-UI theme
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleInventoryClick = () => {
    handleMenuClose();
    navigate('/inventory'); 
  };

  const handleDataETL = () => {
    handleMenuClose();
    navigate('/dataetl'); 
  };

  const handleHomeClick = () => {
    handleMenuClose();
    navigate('/'); 
  };

  return (
    <AppBar position="fixed"
      sx={{
        background: `linear-gradient(to right, white 0px, white 70px, ${theme.palette.primary.main} 120px)`, // Gradient transition
      }}>
      <Toolbar>
        <Box display="flex" alignItems="center" width="100%">
          <IconButton onClick={handleMenuOpen} edge="start">
            <img src={smllogo} alt="Logo" style={{ height: 40 }} />
          </IconButton>

          <Typography variant="h6" style={{ marginLeft: 10 }}>
            Alpha Grand Rapids
          </Typography>

          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={handleHomeClick}>Alpha Bucks Updater</MenuItem>
            <MenuItem onClick={handleInventoryClick}>Inventory Tracker</MenuItem>
            <MenuItem onClick={handleDataETL}>Data Management</MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
